import { EMetaStatus, IFiltersState, EGeoSuggestionsStatus } from '../../types/filters';

export const defaultState: IFiltersState = {
  jsonQuery: {
    _type: 'flatsale',
    engine_version: { type: 'term', value: 2 },
  },
  meta: {
    status: EMetaStatus.Initial,
    url: '',
    mapUrl: '',
    count: 0,
  },
  geoSuggestions: {
    status: EGeoSuggestionsStatus.Initial,
    suggestions: { },
    sortOrder: [],
  },
};
